import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { ForbiddenView } from "@/views/common/forbidden.view";
import { NotFoundView } from "@/views/common/notfound.view";
import { OccupationDetailView } from "@/views/occupation-detail/occupation-detail.view";
import { Route, Switch } from "wouter";
import { CreateView } from "./create/create.view";
import { OccupationView } from "./occupation.view";
import { UpdateView } from "./update/update.view";

export function OccupationRoutes() {
  const ability = useAbility();
  const occupationUpdateUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const occupationDetailUuidRegex = generateUuidV4Regex({ paramName: "uuid" });
  const canManage = ability.can(Action.Manage, "Occupation");

  return (
    <Switch>
      <Route path={"/"} component={OccupationView} />
      <Route path={"/create"} component={canManage ? CreateView : ForbiddenView} />
      <Route path={occupationUpdateUuidRegex} component={canManage ? UpdateView : ForbiddenView} />
      <Route path={occupationDetailUuidRegex} component={OccupationDetailView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
